import { formatNumbers } from 'core/helpers/format-numbers'

import c from './assets/sass/referral-user.module.scss'

export const ReferralUser = ({ user, onClick }) => {
    const avatar = user.photoUrl || '/images/avatar.png'
    const displayName = user.username || user.firstName || 'Пользователь'
    const firstLetter = displayName.charAt(0).toUpperCase()

    const handleCopyUserId = (e) => {
        e.stopPropagation()
        navigator.clipboard.writeText(user.id)
        alert(
            '✅ User ID скопирован!\n\nМожете вставить его в поле "Детекция ботов"'
        )
    }

    return (
        <div className={c.component} onClick={onClick}>
            {user.photoUrl ? (
                <img src={avatar} alt={displayName} className={c.avatar} />
            ) : (
                <div className={c.avatarPlaceholder}>{firstLetter}</div>
            )}
            <div className={c.info}>
                <span className={c.name}>{displayName}</span>
                <span className={c.tgId}>TG ID: {user.telegramId}</span>
                <span
                    className={c.userId}
                    onClick={handleCopyUserId}
                    title="Нажмите чтобы скопировать User ID"
                >
                    User ID: {user.id?.substring(0, 8)}... 📋
                </span>
            </div>
            <div className={c.stats}>
                <div className={c.stat}>
                    <span className={c.statLabel}>Рефералов</span>
                    <span className={c.statValue}>{user.referralsCount}</span>
                </div>
                {user.currentLevel && (
                    <div className={c.stat}>
                        <span className={c.statLabel}>Уровень</span>
                        <span className={c.statValue}>{user.currentLevel}</span>
                    </div>
                )}
                <div className={c.stat}>
                    <span className={c.statLabel}>Заработано</span>
                    <span className={c.statValue}>
                        {formatNumbers(
                            parseInt(user.totalEarned || user.earnings || 0)
                        )}
                    </span>
                </div>
            </div>
        </div>
    )
}
